module.exports = __webpack_public_path__ + "img/daoru.209f5741.svg";